var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overview max-size"},[_c('div',{staticClass:"overview-container"},[_c('CardsContainer',{staticClass:"overview__people-list"}),_c('div',{staticClass:"overview-container-legacy"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }